import { Base64 } from "js-base64";
class LocalStore {
  constructor(type, nameSpace, version, encrypt) {
    this.$store = window[`${type}Storage`];
    this.nameSpace = nameSpace;
    this.version = version;
    this.encrypt = encrypt;
  }
  encode(str) {
    return Base64.encode(str);
  }
  decode(str) {
    return Base64.decode(str);
  }
  genKey(key) {
    return this.encode(`${this.nameSpace}@${key}@${this.version}`);
  }
  set(key, value) {
    let convertedValue =
      typeof value === "object" ? JSON.stringify(value) : value;
    this.$store.setItem(
      this.genKey(key),
      this.encrypt ? this.encode(convertedValue) : convertedValue
    );
  }
  get(key) {
    let valued = this.$store.getItem(this.genKey(key)) || "";
    valued = this.decode(valued);
    try {
      valued = valued && JSON.parse(valued);
    } catch (err) {
      // console.warn(err);
    }
    return valued;
  }
  remove(key) {
    this.$store.removeItem(this.genKey(key));
  }
  clear() {
    this.$store.clear();
  }
}

export const localStore = new LocalStore("local", "ykb", "2026", true);
export const internalStore = new LocalStore("session", "ykb", "2026", true);
